export default {"src":"/_next/static/media/fireworks.colour.b6cc6428.svg","height":364,"width":364,"blurWidth":0,"blurHeight":0};